import { map as _map, max as _max } from 'lodash';
import moment from 'moment';

import { USAGE_DURATION_TYPES, USAGE_INTERVAL_TYPES } from '../../../Utils/Enums';

import styles from './ChartUsageCard.Styles';

const getChartColumnStyles = period => {
  switch (period) {
    case USAGE_DURATION_TYPES.DAY:
      return { columnWidth: 2, columnBorderRadius: 2 };
    case USAGE_DURATION_TYPES.WEEK:
      return { columnWidth: 4, columnBorderRadius: 4 };
    case USAGE_DURATION_TYPES.MONTH:
      return { columnWidth: 8, columnBorderRadius: 4 };
    default:
      return { columnWidth: 4, columnBorderRadius: 4 };
  }
};

const getChartContainerStyle = _period => {
  return _period === 'Day' ? styles.chartContainerStyle : null;
};

const shouldDisplayHours = _hour => !(_hour % 6);

const getChartTimeLabels = ({ usageInterval, usageDuration, startDate, endDate }) => {
  switch (usageInterval) {
    case USAGE_INTERVAL_TYPES.HOUR:
      const startDateUTCfalse = moment(startDate).utc(false);
      if (shouldDisplayHours(moment(startDateUTCfalse).hour())) {
        return {
          startDate: moment(startDateUTCfalse).format('HH:mm'),
        };
      }
      return null;
    case USAGE_INTERVAL_TYPES.DAY:
      return {
        startDate: moment(startDate).format('ddd'),
      };
    case USAGE_INTERVAL_TYPES.WEEK:
      return {
        startDate: moment(startDate).format('D MMM'),
        endDate: moment(endDate).format('D MMM'),
      };
    default:
      return {};
  }
};

const getChartData = ({ period, usage }) => {
  const maxValue = _max(_map(usage, u => parseFloat(u?.usage?.value)));
  const data = _map(usage, usageItem => {
    return {
      ...getChartTimeLabels({ ...period, ...usageItem }),
      values: [{ value: (usageItem?.usage?.value / maxValue) * 100 }],
    };
  });
  const { usageInterval } = period;
  if (usageInterval === USAGE_INTERVAL_TYPES.HOUR) {
    data.push({
      startDate: '24:00',
      values: [{ value: 0 }],
    });
  }
  return data;
};

export { getChartColumnStyles, getChartTimeLabels, getChartData, getChartContainerStyle };
